import ReactGA from "react-ga4";
import { ReactNode, useEffect } from "react";
import config from "../../../config";

let initialized = false;

const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    if (initialized) {
      return;
    }

    ReactGA.initialize([{ trackingId: config.gaAcc! }]);

    initialized = true;
  }, []);

  return children;
};

export default AnalyticsProvider;
